import React from 'react'
import { Link } from 'react-router-dom'

function Blog() {
  return (
    <div>
      <div className="blog-area home-blog blog-2-col default-padding bottom-less">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">Blog Insight</h4>
                <h2 className="title split-text">
                  Top Picks This Week
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            {/* Single Item */}
            <div className="col-xl-6 col-md-6 col-lg-6 mb-30">
              <div className="home-blog-style-one-item wow fadeInUp">
                <div className="home-blog-thumb">
                  <img title='Microcode Software' src="static/img/blog/2.jpg" alt="Img Not Found" />
                  <ul className="home-blog-meta">
                    <li>
                      <a href="#"> digital marketing</a>
                    </li>
                    <li>October 18, 2024</li>
                  </ul>
                </div>
                <div className="content">
                  <div className="info">
                    <h2 className="blog-title">
                      <Link to="/how-ai-is-revolutionizing-digital-marketing-trends-and-predictions">
                        How AI is Revolutionizing Digital Marketing: Trends and Predictions
                      </Link>
                    </h2>
                    <Link to="/how-ai-is-revolutionizing-digital-marketing-trends-and-predictions" className="btn-read-more">
                      Read More <i className="fas fa-long-arrow-right" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {/* End Single Item */}
            {/* Single Item */}
            <div className="col-xl-6 col-md-6 col-lg-6 mb-30">
              <div
                className="home-blog-style-one-item wow fadeInUp"
                data-wow-delay="200ms"
              >
                <div className="home-blog-thumb">
                  <img title='Microcode Software' src="static/img/blog/3.jpg" alt="Img Not Found" />
                  <ul className="home-blog-meta">
                    <li>
                      <a href="#">technology</a>
                    </li>
                    <li>August 26, 2024</li>
                  </ul>
                </div>
                <div className="content">
                  <div className="info">
                    <h2 className="blog-title">
                      <Link to="/the-future-of-digital-interaction-and-business">
                        Exploring the Metaverse: The Future of Digital Interaction & Business
                      </Link>
                    </h2>
                    <Link to="/the-future-of-digital-interaction-and-business" className="btn-read-more">
                      Read More <i className="fas fa-long-arrow-right" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {/* End Single Item */}
          </div>
        </div>
      </div>

    </div>
  )
}

export default Blog
